import { API } from '@/redux/config';
import { toast } from 'react-toastify';
import {
  start,
  resetFilePropertiesStart,
  getCurrentFolderItemsStart,
  setReducerError,
  setDiagramsDirectory,
  setToggleRenameFolder,
  setCurrentFolderPath,
  setNewFolder,
  setToggleCreateFolder,
  setCustomerFolder,
  setCustomerDirectory,
  setCurrentDirectory,
  setDownloadFile,
  setUploadFile,
  setToggleUploadFile,
  setArchivedFile,
  setRestoredFile,
  setToggleRestoreItem,
  setDeleteFile,
  setDuplicateFile,
  setFileProperties,
  setRecyclingBin,
  setToggleRecyclingBin,
  setToggleDeleteArchiveItem,
  setToggleRenameFile,
  setFolderProperties,
  setRestoredFolder,
  setDeleteFolder,
  setDuplicateFolder,
  setRenameFolder,
  setFolderPropertiesToggle,
  setDeleteItemFromRecyclebin,
  setFilePreview,
} from '../reducers/sharepointReducer';
import { raiseErrorException } from '../../utils/raiseErrorException';

// Get Folder Structure of Customer
export const getFoldersByCustomer = (customerID) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.get('/sharepoint/get_all_folders', {
      params: { customerID },
    });

    dispatch(setCustomerFolder(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Properties of Folder and Enclosed Items
export const getCurrentFolderItems = (folderPath) => async (dispatch) => {
  try {
    dispatch(getCurrentFolderItemsStart());
    const response = await API.get(`/sharepoint/current_folder_items?folderPath=${folderPath}`);

    dispatch(setCurrentDirectory(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Properties of Folder and Enclosed Items
export const getSharepointDiagrams = (folderPath) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.get(`/sharepoint/current_folder_items?folderPath=${folderPath}`);

    dispatch(setDiagramsDirectory(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Properties of Customer Specified Folder and Enclosed Items
export const getCurrentFolderItemsByCustomer =
  (customerID, folderPath = null) =>
  async (dispatch) => {
    try {
      dispatch(resetFilePropertiesStart());
      const response = await API.get('/sharepoint/current_folder_items/customer/', {
        params: { customerID, ...(folderPath && { folderPath }) },
      });

      dispatch(setCustomerDirectory(response?.data));
    } catch (err) {
      raiseErrorException(err, dispatch, setReducerError, 'get');
    }
  };

// Get File Properties
export const getFileProperties = (filePath) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.get('/sharepoint/file_properties/', {
      params: { filePath },
    });

    dispatch(setFileProperties(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Download File
export const downloadFile = (filePath) => async (dispatch) => {
  try {
    dispatch(start());

    const response = await API.get('/sharepoint/download_file/', {
      params: { filePath },
      responseType: 'blob',
    });

    // Extract filename from Content-Disposition header
    const header = response.headers['content-disposition'];
    let filename = 'downloaded_file'; // Default name if extraction fails
    if (header) {
      const matches = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    // Create Blob URL and download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url); // Revoke Blob URL to free memory

    dispatch(setDownloadFile()); // Consider renaming to downloadSuccess()
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Upload File into Folder
export const uploadFile =
  (file, folderPath, replace, toggle = () => {}, setError, setFilePath = () => {}, setFolderPath = () => {}, path) =>
  async (dispatch) => {
    try {
      dispatch(start());
      const data = new FormData();
      data.append('file', file);
      const result = await API.post(
        '/sharepoint/upload_file/',
        data,

        { params: { folderPath, ...(replace && { replace }) } },
      );

      dispatch(setUploadFile(result?.data));
      toggle();
      setError(null);
      toast.success('File Uploaded Successfully');
      dispatch(getCurrentFolderItems(folderPath));
    } catch (err) {
      setError(err?.response?.data?.detail);
      setFilePath(file);
      setFolderPath(folderPath);

      // dispatch(setReducerError(err?.response?.data?.detail));
      raiseErrorException(err, dispatch, setReducerError, 'post');
    }
  };
// Toggles the Modal that Allows for a File Upload
export const toggleUploadNewFile = (state) => async (dispatch) => {
  dispatch(setToggleUploadFile(state));
};

// Duplicate File
export const duplicateFile = (filePath) => async (dispatch) => {
  try {
    dispatch(start());
    const result = await API.post(`/sharepoint/duplicate_file?filePath=${filePath}`);
    toast.success('File Sucessfully Duplicated');

    dispatch(setDuplicateFile(result?.data));
    const file = filePath.split('/');
    const path = file
      .slice(0, file.length - 1)
      .join(',')
      .replaceAll(',', '/');
    toast.success('File Successfully Duplicated');

    dispatch(getCurrentFolderItems(path));
  } catch (err) {
    // toast.error('An error encountered');

    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

// Toggles The Modal that Allows for File Rename
export const renameFileToggle = (state) => (dispatch) => {
  dispatch(setToggleRenameFile(state));
};

/// Get Items From Recycling Bin
export const toggleRecyclingBinModal = (state) => (dispatch) => {
  dispatch(setToggleRecyclingBin(state));
};

export const getItemsFromRecyclingBin = (customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/sharepoint/recycling_bin`);

    dispatch(setRecyclingBin(response?.data));
  } catch (err) {
    // toast.error('An error encountered');

    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const DeleteArchiveToggle = (state) => (dispatch) => {
  dispatch(setToggleDeleteArchiveItem(state));
};

export const deleteItemFromRecycleBin = (customerID, recycleBinId) => async (dispatch) => {
  const message = toast.loading('Deleting Item From Recycling Bin...');
  try {
    dispatch(start());
    const response = await API.delete(`/sharepoint/recycling_bin/delete?recycleBinId=${recycleBinId}`);

    dispatch(setDeleteItemFromRecyclebin(response?.data));
    toast.update(message, {
      render: 'Deleted Successfully',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
    dispatch(getItemsFromRecyclingBin(customerID));
  } catch (err) {
    toast.update(message, {
      render: `${err.response.data.detail}`,
      type: 'error',
      isLoading: false,
    });

    dispatch(setReducerError(err?.response?.data));
    // raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};

// Move File to Recycle Bin
export const moveFileToRecycleBin = (filePath) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.delete('/sharepoint/archive_file/', {
      params: { filePath },
    });
    toast.success('File Moved to Recycling Bin');

    dispatch(setArchivedFile(response?.data));
    const file = filePath.split('/');
    const path = file
      .slice(0, file.length - 1)
      .join(',')
      .replaceAll(',', '/');
    dispatch(getCurrentFolderItems(path));
  } catch (err) {
    // toast.error('An error encountered');

    // dispatch(setReducerError(err?.response?.data?.detail));
    raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};

export const RestoreToggle = (state) => (dispatch) => {
  dispatch(setToggleRestoreItem(state));
};

// Restore File -- move file from Recycle Bin to original location
export const restoreFileFromRecycleBin = (recycleBinId) => async (dispatch) => {
  const message = toast.loading('Retrieving Document From Recycling Bin...');
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.put(`/sharepoint/restore_file/?recycleBinId=${recycleBinId}`);

    dispatch(setRestoredFile(response?.data));
    toast.update(message, {
      render: 'Retrieval Successful',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
  } catch (err) {
    toast.update(message, {
      render: `${err.response.data.detail}`,
      type: 'error',
      isLoading: false,
    });

    dispatch(setReducerError(err?.response?.data));
  }
};

// Delete File Permanently from Shared Documents
export const deleteFilePermanently = (filePath) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete('/sharepoint/delete_file/', {
      params: { filePath },
    });
    toast.success('File Sucessfully Deleted');

    dispatch(setDeleteFile(response?.data));
    const file = filePath.split('/');
    const path = file
      .slice(0, file.length - 1)
      .join(',')
      .replaceAll(',', '/');
    dispatch(getCurrentFolderItems(path));
  } catch (err) {
    // toast.error('An error encountered');

    // dispatch(setReducerError(err?.response?.data?.detail));
    raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};

// Get Folder Properties
export const getFolderProperties = (folderPath) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.get(`/sharepoint/folder_properties?folderPath=${folderPath}`);

    dispatch(setFolderProperties(response?.data));
  } catch (err) {
    toast.error('An error encountered');

    dispatch(setReducerError(err?.response?.data));
  }
};

export const toggleFolderProperties = (state) => async (dispatch) => {
  dispatch(setFolderPropertiesToggle(state));
};

// Add new Folder
export const createFolder = (folderName, folderPath, customerID, toggle) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const response = await API.post(`/sharepoint/new_folder?folderPath=${folderPath}&folderName=${folderName}`);
    toast.success('Folder Sucessfully created');

    dispatch(setNewFolder(response?.data));
    toggle();
    dispatch(getFoldersByCustomer(customerID));
  } catch (err) {
    toast.error('An error encountered');

    dispatch(setReducerError(err?.response?.data));
  }
};

// Duplicate Folder and its Contents
export const duplicateFolder = (folderPath, customerID) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const result = await API.post(`/sharepoint/duplicate_folder?folderPath=${folderPath}`);
    toast.success('Folder Successfully Duplicated');

    dispatch(setDuplicateFolder(result?.data));
    dispatch(getFoldersByCustomer(customerID));
  } catch (err) {
    // -  toast.error('An error encountered');

    // dispatch(setReducerError(err?.response?.data?.detail));
    raiseErrorException(err, dispatch, setReducerError, 'post');
  }
};

// Rename Folder
export const renameFolderToggle = (state) => (dispatch) => {
  dispatch(setToggleRenameFolder(state));
};
export const renameFolder = (folderPath, newName, customerID, toggle) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());
    const result = await API.put(`/sharepoint/rename_folder?folderPath=${folderPath}&newName=${newName}`);

    dispatch(setRenameFolder(result?.data));
    toggle();
    toast.success('Folder Successfully Renamed');
    dispatch(getFoldersByCustomer(customerID));
  } catch (err) {
    // toast.error(`Error: ${err?.response?.data?.detail}.`);

    // dispatch(setReducerError(err?.response?.data?.detail));
    raiseErrorException(err, dispatch, setReducerError, 'put');
  }
};

// Restore Folder from recycle bin to original location
export const restoreFolder = (recycleBinId) => async (dispatch) => {
  const message = toast.loading('Retrieving Folder From Recycling Bin...');
  try {
    dispatch(start());
    const response = await API.put(`/sharepoint/restore_folder?recycleBinId=${recycleBinId}`);

    dispatch(setRestoredFolder(response?.data));
    toast.update(message, {
      render: 'Retrieval Successful',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
  } catch (err) {
    toast.update(message, {
      render: `${err.response.data.detail}`,
      type: 'error',
      isLoading: false,
    });

    dispatch(setReducerError(err?.response?.data?.detail));
    // raiseErrorException(err, dispatch, setReducerError, 'put');
  }
};

// Permanently Delete Folder From Shared Documents
export const deleteFolderPermanently = (folderPath, customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete('/sharepoint/delete_folder/', {
      params: { folderPath },
    });
    toast.success('Folder Successfully Deleted');

    dispatch(setDeleteFolder(response?.data));
    dispatch(getFoldersByCustomer(customerID));
  } catch (err) {
    // toast.error('An error encountered');

    // dispatch(setReducerError(err?.response?.data));
    raiseErrorException(err, dispatch, setReducerError, 'delete');
  }
};

export const getImagePreview = (link, index) => async (dispatch) => {
  try {
    dispatch(resetFilePropertiesStart());

    dispatch(setFilePreview({ imagePreview: link, index }));
  } catch (err) {
    // dispatch(setReducerError(err?.response?.data));
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Setting the Current Path When a Folder is Selected
export const setCurrentPath = (path) => async (dispatch) => {
  dispatch(setCurrentFolderPath(path));
};

// Toggle The Modal that Creates a New Folder
export const toggleCreateNewFolder = (state) => async (dispatch) => {
  dispatch(setToggleCreateFolder(state));
};
